import {
	caseByID,
	caseCreate,
	caseDestroy,
	caseList,
	caseUpdate,
} from '@/services/agency/cases.service'

export default {
	namespaced: true,
	state: {
		// SERVICE CASE
		caseList: {
			meta: {
				pagination: {
					total: 0,
				},
			},
		},
		case: {},

		// STATUS SERVICE CASE
		caseStatus: 'pending',
		caseSaveStatus: 'init',
		caseDeleteStatus: 'init',
	},
	getters: {
		// SERVICE CASE
		getCaseList(state) {
			return state.caseList
		},
		getCase(state) {
			return state.case
		},

		// SERVICE STATUS
		getStatusList(state) {
			return state.statusList
		},
		getStatus(state) {
			return state.status
		},

		// SERVICE CASE
		getCaseDeleteStatus(state) {
			return state.caseDeleteStatus
		},
		getCaseSaveStatus(state) {
			return state.caseSaveStatus
		},
		getCaseStatus(state) {
			return state.caseStatus
		},
	},
	mutations: {
		// SERVICE CASE
		CASE_LIST(state, value) {
			state.caseList = value
		},
		SET_CASE(state, value) {
			state.case = value
		},

		// STATUS SERVICE CASE
		CASE_STATUS(state, value) {
			state.caseStatus = value
		},
		CASE_SAVE_STATUS(state, value) {
			state.caseSaveStatus = value
		},
		CASE_DELETE_STATUS(state, value) {
			state.caseDeleteStatus = value
		},
	},
	actions: {
		// Service Case
		async fetchCaseList({ commit }, params) {
			window.scrollTo({ top: 0, behavior: 'smooth' })
			commit('CASE_STATUS', 'pending')
			commit('CASE_LIST', {
				meta: {
					pagination: {
						total: 0,
					},
				},
			})
			try {
				const { data } = await caseList(params)
				commit('CASE_STATUS', 'init')
				commit('CASE_LIST', data)
				return data
			} catch (error) {
				commit('CASE_STATUS', 'init')
				throw error
			}
		},
		async fetchCaseByID({ commit }, params) {
			commit('CASE_STATUS', 'pending')
			try {
				const { data } = await caseByID(params)
				commit('CASE_STATUS', 'init')
				commit('SET_CASE', data.data)
				return data
			} catch (error) {
				commit('CASE_STATUS', 'init')

				return error
			}
		},
		async saveNewCase({ commit }, params) {
			commit('CASE_SAVE_STATUS', 'pending')
			try {
				const { data } = await caseCreate(params)
				commit('CASE_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('CASE_SAVE_STATUS', 'init')
				throw error
			}
		},
		async updateCase({ commit }, params) {
			commit('CASE_SAVE_STATUS', 'pending')
			try {
				const { data } = await caseUpdate(params)
				commit('CASE_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('CASE_SAVE_STATUS', 'init')
				throw error
			}
		},
		async deleteCaseByID({ commit }, params) {
			commit('CASE_DELETE_STATUS', 'pending')
			try {
				const { data } = await caseDestroy(params)
				commit('CASE_DELETE_STATUS', 'init')
				return data
			} catch (error) {
				commit('CASE_DELETE_STATUS', 'error')

				return error
			}
		},
	},
}
